import { imagePathResolver, NumberFormats as nf, ROUTES, useClientConfig, useCurrencyFormatter } from '@shared/utils';
import { useTranslations } from 'next-intl';
import type { GameDetails } from '../../casino/types/types';
import { ClassicGameCard } from '../../ClassicGameCard/ClassicGameCard';
import type { ClassicGameListProps } from './types';

function ClassicGameList({ namespace, games, variant = 'grid', cardClassName, onRemoveGameRef, baseUrl = ROUTES.CASINO }: ClassicGameListProps) {
  const t = useTranslations(namespace);
  const formatCurrency = useCurrencyFormatter();
  const { baseImgUrl } = useClientConfig();

  const getGameSubtitle = (provider?: string[], volatility?: string[]) => {
    const providerName = provider?.[0];
    const volatilityLevel = volatility?.[0];

    if (providerName && volatilityLevel) {
      return `${providerName} - ${volatilityLevel}`;
    }
    if (providerName) {
      return providerName;
    }
    if (volatilityLevel) {
      return volatilityLevel;
    }
    return undefined;
  };

  return (
    <>
      {games.map(({ image, jackpot, isFavourite, name, displayName, provider, volatility }: GameDetails, index: number) => (
        <ClassicGameCard
          className={cardClassName}
          variant={variant}
          key={name}
          id={name}
          gameName={displayName}
          backgroundImage={imagePathResolver(image, baseImgUrl, true)}
          href={baseUrl.GAME(name)}
          playButtonText={t('play')}
          jackpotLabelText={jackpot ? formatCurrency(jackpot).format(nf.WITHOUT_DECIMALS).get() : undefined}
          isFavourited={isFavourite}
          infoButtonHref={baseUrl.GAME_INFO(name)}
          gameProvider={provider?.[0] ?? ''}
          subtitle={variant === 'list' ? getGameSubtitle(provider, volatility) : undefined}
          position={index + 1}
          onRemoveGameRef={onRemoveGameRef}
        />
      ))}
    </>
  );
}

export { ClassicGameList };
